/* ============================================================
   Ogé Exclusive, validatie van het zakelijke aanmeldformulier
   ============================================================

   Progressive enhancement. Het formulier heeft in de HTML al
   `required` en `pattern` staan, dus zonder dit script valideert de
   browser zelf, alleen met eigen, vaak Engelse meldingen. Dit script
   neemt dat over zodra het geladen is: het zet `novalidate` op het
   formulier (pas op dat moment, nooit in de HTML) en toont
   Nederlandse meldingen onder het veld.

   Faalt het script, dan blijft de native validatie de vangrail.
   Serverzijde blijft Shopify's contactformulier leidend; dit is
   uitsluitend gebruiksgemak, geen beveiliging.
   ============================================================ */
(function () {
  'use strict';

  var KVK = /^[0-9]{8}$/;
  // Nederlands (NL123456789B01) of Belgisch (BE0123456789).
  var BTW = /^(NL[0-9]{9}B[0-9]{2}|BE[01][0-9]{9})$/;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /** Meldingen per veld. `required` is de tekst als het veld leeg is,
   *  `invalid` die als er wél iets staat maar in het verkeerde formaat. */
  var MESSAGES = {
    required: 'Dit veld is verplicht.',
    email: 'Vul een geldig e-mailadres in, bijvoorbeeld naam@salon.nl.',
    tel: 'Vul een geldig telefoonnummer in.',
    kvk: 'Een KVK-nummer bestaat uit precies 8 cijfers, zonder spaties of punten.',
    btw: 'Gebruik het formaat NL123456789B01 of, voor België, BE0123456789.',
    url: 'Vul een volledig webadres in, bijvoorbeeld https://www.uwsalon.nl of uw Instagram-link.',
    postcode: 'Vul een geldige postcode in, bijvoorbeeld 1012 AB.',
    consent: 'U moet akkoord gaan met de algemene voorwaarden om de aanvraag te versturen.'
  };

  var POSTCODE = /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/;

  function fieldOf(input) {
    return input.closest('.b2b-field, .b2b-form__consent-field');
  }

  function errorNodeOf(input) {
    var wrap = fieldOf(input);
    return wrap ? wrap.querySelector('.b2b-field__error') : null;
  }

  function clear(input) {
    var wrap = fieldOf(input);
    if (!wrap) return;
    wrap.removeAttribute('data-invalid');
    input.removeAttribute('aria-invalid');
  }

  function fail(input, message) {
    var wrap = fieldOf(input);
    var node = errorNodeOf(input);
    if (!wrap || !node) return;
    node.textContent = message;
    wrap.setAttribute('data-invalid', 'true');
    input.setAttribute('aria-invalid', 'true');
  }

  /** Geeft null terug als het veld in orde is, anders de melding. */
  function checkOne(input) {
    // Uitgeschakelde en verborgen velden (honeypot) nooit valideren.
    if (input.disabled || input.type === 'hidden') return null;

    var value = (input.value || '').trim();
    var rule = input.getAttribute('data-b2b-rule');
    var isRequired = input.hasAttribute('required');

    if (input.type === 'checkbox') {
      if (isRequired && !input.checked) return MESSAGES.consent;
      return null;
    }

    if (!value) return isRequired ? MESSAGES.required : null;

    switch (rule) {
      case 'kvk':
        // Spaties en punten die mensen er zelf in typen tellen niet mee.
        return KVK.test(value.replace(/[\s.]/g, '')) ? null : MESSAGES.kvk;
      case 'btw':
        return BTW.test(value.replace(/[\s.]/g, '').toUpperCase()) ? null : MESSAGES.btw;
      case 'postcode':
        return POSTCODE.test(value) ? null : MESSAGES.postcode;
      default:
        break;
    }

    if (input.type === 'email') return EMAIL.test(value) ? null : MESSAGES.email;
    if (input.type === 'tel') {
      // Bewust ruim: +31, 0031, spaties, streepjes en haakjes zijn allemaal
      // normaal. We eisen alleen dat er minstens 8 cijfers in zitten.
      return (value.match(/[0-9]/g) || []).length >= 8 ? null : MESSAGES.tel;
    }
    if (input.type === 'url') {
      return /^(https?:\/\/|www\.)\S+\.\S+/i.test(value) || /^@?[\w.]+$/.test(value)
        ? null
        : MESSAGES.url;
    }

    return null;
  }

  function normalise(input) {
    var rule = input.getAttribute('data-b2b-rule');
    if (rule === 'kvk') {
      input.value = input.value.replace(/[\s.]/g, '');
    } else if (rule === 'btw') {
      input.value = input.value.replace(/[\s.]/g, '').toUpperCase();
    } else if (rule === 'postcode') {
      input.value = input.value.toUpperCase().replace(/^([1-9][0-9]{3})\s?([A-Z]{2})$/, '$1 $2');
    }
  }

  function init(panel) {
    // `{% form 'contact' %}` rendert het <form>-element zelf, dus we kunnen
    // er in Liquid geen data-attribuut op zetten. Het merk staat op de
    // panel-div eromheen; het echte formulier zoeken we hier op. Zonder
    // deze stap zou novalidate op een <div> belanden en niets doen.
    var form = panel.closest('form');
    if (!form || form.dataset.b2bReady === 'true') return;
    form.dataset.b2bReady = 'true';

    // Pas hier uitzetten: als dit script nooit draait, blijft de native
    // validatie het formulier bewaken.
    form.setAttribute('novalidate', 'novalidate');

    var summary = form.querySelector('[data-b2b-summary]');
    var honeypot = form.querySelector('[data-b2b-hp]');
    var fields = Array.prototype.slice.call(
      form.querySelectorAll('[data-b2b-validate]')
    );

    // "Anders" bij type onderneming klapt een open veld uit.
    // Verborgen staat het op disabled: zo wordt het niet meeverstuurd (een
    // lege regel in de notificatiemail) en slaat checkOne het over.
    var otherToggle = form.querySelector('[data-b2b-other-toggle]');
    var otherField = form.querySelector('[data-b2b-other-field]');
    if (otherToggle && otherField) {
      var otherInput = otherField.querySelector('input');
      var otherValue = otherToggle.getAttribute('data-b2b-other-value') || 'Anders';

      var syncOther = function (focusIt) {
        var wanted = otherToggle.value === otherValue;
        otherField.hidden = !wanted;
        if (otherInput) {
          otherInput.disabled = !wanted;
          if (wanted) {
            otherInput.setAttribute('required', 'required');
            if (focusIt) otherInput.focus();
          } else {
            otherInput.removeAttribute('required');
            otherInput.value = '';
            clear(otherInput);
          }
        }
      };

      // false: bij het opbouwen van de pagina niet de focus wegtrekken.
      syncOther(false);
      otherToggle.addEventListener('change', function () {
        syncOther(true);
      });
    }

    fields.forEach(function (input) {
      // Pas melden nadat iemand het veld verlaten heeft, meetypen en
      // meteen een rode fout krijgen is vervelend.
      input.addEventListener('blur', function () {
        normalise(input);
        var message = checkOne(input);
        if (message) fail(input, message);
        else clear(input);
      });

      // Zodra een fout getoond is, meteen weer opruimen als het klopt.
      var live = input.type === 'checkbox' || input.tagName === 'SELECT' ? 'change' : 'input';
      input.addEventListener(live, function () {
        var wrap = fieldOf(input);
        if (!wrap || wrap.getAttribute('data-invalid') !== 'true') return;
        if (!checkOne(input)) clear(input);
      });
    });

    form.addEventListener('submit', function (event) {
      // Honeypot: alleen een bot vult een veld in dat buiten beeld staat,
      // aria-hidden is en niet met tab bereikbaar. Stil afbreken, zonder
      // melding, een bot die te horen krijgt waaróm hij faalt, past zich aan.
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        return;
      }

      var problems = [];

      fields.forEach(function (input) {
        normalise(input);
        var message = checkOne(input);
        if (message) {
          fail(input, message);
          problems.push({ input: input, message: message });
        } else {
          clear(input);
        }
      });

      if (!problems.length) {
        if (summary) summary.hidden = true;
        return;
      }

      event.preventDefault();

      if (summary) {
        var list = summary.querySelector('ul');
        if (list) {
          list.innerHTML = '';
          problems.forEach(function (problem) {
            var label = form.querySelector('label[for="' + problem.input.id + '"]');
            var name = label ? label.textContent.trim().replace(/\s+/g, ' ') : '';
            var li = document.createElement('li');
            // Een anker in de samenvatting brengt een schermlezer met één
            // toets naar het veld dat aandacht nodig heeft.
            var link = document.createElement('a');
            link.href = '#' + problem.input.id;
            link.textContent = name ? name + ': ' + problem.message : problem.message;
            link.addEventListener('click', function (e) {
              e.preventDefault();
              problem.input.focus();
            });
            li.appendChild(link);
            list.appendChild(li);
          });
        }
        summary.hidden = false;
        summary.focus();
      }

      problems[0].input.focus();
    });
  }

  function boot() {
    document.querySelectorAll('[data-b2b-form]').forEach(init);

    // Na een geslaagde verzending laadt Shopify de pagina opnieuw met
    // ?contact_posted=true. De focus staat dan bovenaan, terwijl de
    // bevestiging halverwege de pagina staat, die verplaatsen we, zodat
    // een schermlezer hem voorleest en niemand hoeft te zoeken of het
    // gelukt is.
    var confirmed = document.querySelector('[data-b2b-confirm]');
    if (confirmed) {
      confirmed.focus({ preventScroll: true });
      confirmed.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // De theme editor hertekent secties zonder de pagina te herladen.
  document.addEventListener('shopify:section:load', boot);
})();
